export function applyPerformanceDataFilter(
  featureFlagIsActive: boolean,
  key: string,
  slug: string
) {
  return (data: any) => {
    return featureFlagIsActive ? true : slug !== data[key];
  };
}
